<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Partner
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Partner</a>
        </li>
      </ul>
    </div>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? 'Information' : 'Generation'" border-variant="primary" >
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Partner Info
            </div>
            <div class="mb7">
              <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | sdate}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" label-for="ph_use">
                Allow login
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock" />
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="" v-b-tooltip.hover title="Only the 'owner' account can set up invoicing.">
                Invoice Email Notice
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Invoice_Email_Notice" :disabled="lock || model.parent_id && model.parent_id != model.id" v-model="model.allow_invoice" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
              <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph">
                Permissions
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <select class="form-control" :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions">
                <option v-for="(item, index) in codes.permissions_partner" :key="index" :value="item">{{ item }}</option>
              </select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
              <label class="col-form-label" for="">
                Last_visit
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.id">
              {{model.last_visit | datetime}} @ {{model.last_addr ? model.last_addr : '-'}}
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="!model.id">
              <label class="col-form-label" for="" v-if="model && !model.parent_id">
                Partner Group connect
              </label>
              <label class="col-form-label" v-else>
                Partner Group :
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="!model.id">
              <label class="col-form-label" for="" v-if="model && !model.parent_id">
                <small>If the partner being created belongs to the same group as the other partner</small>
              </label>
              <label class="col-form-label" v-else>
                {{model.parent_username}}
              </label>
              <b-button class="btn btn-sm margin_t ml-2" variant="primary" @click="partner_connect_modal = true">Search</b-button>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
              <label class="col-form-label" for="">
                Partner Group Owner
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
              <label>{{model.parent_username}}</label>
              <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block :disabled="model.is_del">View</b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username">
                Username(ID)
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-1 col-md-1 align-self-center">
              <b-badge v-if="model && model.id && model.parent_id"  :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * Partner Group {{model.parent_id && model.parent_id == model.id ? ' Master' : 'Member'}}
              </b-badge>
            </b-col>
            <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
              <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" @change="change_username"></b-form-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_nickname">
                Nick Name
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3" v-show="add || !lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_pass">
                {{add ? '' : 'New'}} Password
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                Min Length : 10
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
              <label class="col-form-label" for="ph_pass2">
                Password Repeat
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12" v-if="model.new_password">
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_tax">
                Tax : [%]
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title_sub">
              Region
            </div>
          </div>
          <hr>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_country">
                Country
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" @input="set_country" :disabled="lock" label="name" v-model="region.country">
                <option v-for="(item, index) in codes.country" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_language">
                language
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" @input="set_language" label="name" :disabled="lock" v-model="region.language">
                <option v-for="(item, index) in codes.language" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_timezone">
                Timezone
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" @input="set_timezone" label="name" :disabled="lock" v-model="region.timezone">
                <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_address" v-b-tooltip.hover title="The address to which the invoice should be sent.">
                Address
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">
                List of allowed IPs
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex  flex-wrap align-self-center">
              <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                The logo is using when Invoice
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <img v-if="lock" class="text-center" height="120" width="400" :src="model.logo || '/f1/assets/img/F1-uwss.png'" alt="Hello, F1security">
              <b-form-group v-else>
                <!-- v-show="!confirm_save && !confirm_refresh" -->
                <picture-input
                  :z-index="2"
                  radius="3"
                  :prefill="model.logo"

                  ref="pictureInput"
                  height="140" min-height="150" width="600"  max-width="600" max-height="200"
                  accept="image/*" size="2" button-class="btn btn-dark"
                  :custom-strings="{
                    upload: '<h1>uploading</h1>',
                    drag: '<small>Drag & Drop<small>',
                  }"
                  @change="logo_change">
                </picture-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="12">
              <b-button size="sm" variant="warning"  v-if="lock && !partner" :disabled="model.is_del" @click="edit">
                {{ partner ? 'Partner' : ''}}{{ model.is_del ? 'Partner was deleted' : 'Edit'}}
              </b-button>
              <b-button size="sm" variant="danger" @click="confirm = true" v-if="lock && !partner && !model.is_del" :disabled="model.is_del"> Remove </b-button>
              <b-button size="sm" class="btn btn-cancel" @click="send_password_reset_mail" v-if="lock && model.id && !partner && !model.is_del" :disabled="model.is_del"> Send Password Reset Mail </b-button>
              <b-button size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="lock && model.id && !model.is_del && !partner" :disabled="model.is_del"> Send IP ACL Reset Mail </b-button>

              <b-button v-if="!lock" size="sm" variant="add" @click="save"> Save </b-button>
              <b-button v-if="!lock" size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
              <b-button v-if="partner" size="sm" class="m-1 pull-right" variant="primary" @click="$router.push({ name : 'partner', params : { id : partner.id } })"> Partner Detail </b-button>
              <b-button v-if="!partner" size="sm" class="m-1 pull-right" variant="primary" @click="list"> {{partner ? 'Partner' : ''}} List </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!-- 해당 부모 파트너와 연결되어 있는 멤버 파트너들 정보 -->
      <b-tab :disabled="!model.id" title="Member">
        <b-card>
          <partner-List v-if="check_owner" :enable_new="false" :parent_id="model.id"></partner-List>
          <b-row v-else>
              <b-col sm="12">
                <center>
                  <label>Partner Group : [Owner]</label>
                  <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                  <b-button variant="primary" @click="reload" block>View</b-button>
                </center>
              </b-col>
            </b-row>
        </b-card>
      </b-tab>
      <!-- 파트너 크레딧관리 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Billing Setting">
        <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto">
          </div>
        </div>
        <b-row v-if="check_owner">
          <b-col class="col-xl-6 mb-1">
            <b-card class="g">
              <b-row>
                <b-col class="col-xl-12 d-flex flex-wrap align-items-center justify-content-center">
                  <div class="title_sub">
                    Credit Balance
                    <button type="button" class="btn btn-sm btn-add ml-2" tabindex="4" @click="credit_history_modal = true">
                      History Click
                    </button>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col class="col-xl-12 col-md-12 d-flex flex-wrap align-items-center justify-content-center">
                  <h1 class="display-4 font-weight-bold" style="text-align: center; "><b>${{model.credit | number}}</b></h1>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="col-xl-6 mb-1">
            <b-card class="g">
              <b-row>
                <b-col class="col-xl-12 d-flex flex-wrap align-items-center justify-content-center">
                  <div class="title_sub mb-3">
                    Credit Charging
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col lg="12" xl="12">
                  <b-row class="mb-2">
                    <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                      <label class="col-form-label" for="ph_name">
                        Credit Deposit or Withdraw
                      </label>
                    </b-col>
                    <b-col class="col-xl-8 col-md-12">
                      <b-input-group size="sm" prepend="$">
                        <b-form-input class="form-control" v-model="amount" placeholder="0.00" type="number"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                      <label class="col-form-label" for="ph_address">
                        Credit Info
                        <span class="text-danger ml-1">*</span>
                      </label>
                    </b-col>
                    <b-col class="col-xl-8 col-md-12">
                      <b-textarea class="form-control" v-model="amount_log"></b-textarea>
                    </b-col>
                  </b-row>
                  <div class="d-flex flex-wrap mt-4">
                    <div class="mr-3">
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 10">10</b-button>
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 50">50</b-button>
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 100">100</b-button>
                    </div>
                    <div class="mr-3">
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 10">-10</b-button>
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 50">-50</b-button>
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 100">-100</b-button>
                    </div>
                    <div class="pull-right ml-auto">
                      <b-button size="sm" variant="primary" @click="Credit_Add = true">Update</b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>Partner Group : [Owner]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>View</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 시작 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" @click="get_partner_service" title="Service">
        <b-row v-if="check_owner">
          <b-col>
            <b-card>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title mr-auto">
                  Partner Service
                </div>
                <div class="mb7">
                  <span class="pull-right">Price unit : $</span>
                </div>
              </div>
              <hr>
              <p class="text-danger font-weight-bold">
                1. We recommend setting the partner price immediately after creating the partner
                <br>
                2. Set whether or not to disclose
                <br>
                (price is the first set only once and the default price is will can not set afterward However, promotion is available)
                <br>
                3. The price must be disclosed before the partner can create a customer.
                <br>
                4. F1's profit is recommended at least cost.
              </p>
              <hr>
              <div class="reg_card">
                <div class="reg_card_body">
                  <div class="table-responsive">
                    <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list_price" show-empty empty-text="There is no payment history!" :items="get_partner_service" :fields="pay">
                      <template slot="is_publish" slot-scope="row">
                        <!-- <c-switch color="dark" :disabled="published && row.item.is_publish && publish_list.indexOf(row.item.id) < 0" label size="sm" v-model="row.item.is_publish" @change="toggle_publish_service($event, row.item.id, row.item.is_publish)" /> -->
                        <div class="checkbox-switch">
                          <input type="checkbox" class="input-checkbox" :disabled="published && row.item.is_publish && publish_list.indexOf(row.item.id) < 0" label size="sm" v-model="row.item.is_publish" @change="toggle_publish_service($event, row.item.id, row.item.is_publish)">
                          <div class="checkbox-animate disabled">
                            <span class="checkbox-off">OFF</span>
                            <span class="checkbox-on">ON</span>
                          </div>
                        </div>
                      </template>
                      <template slot="service.name" slot-scope="row">{{row.item.service.name}}</template>
                      <template slot="service.min_price" slot-scope="row">{{row.item.service.min_price | dollar}} </template>
                      <template slot="customer_price" slot-scope="row">
                        <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                          <b-input size="sm" v-model="row.item.customer_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                        </b-input-group>
                      </template>
                      <template slot="benefit.f1" slot-scope="row">
                        {{ (row.item.customer_price - row.item.partner_price) | dollar}}
                        ({{(((row.item.customer_price - row.item.partner_price) / row.item.customer_price) * 100) | decimal}} %)
                      </template>
                      <template slot="benefit.partner" slot-scope="row">
                        <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                          <b-input size="sm" v-model="row.item.partner_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                        </b-input-group>
                      </template>
                      <template slot="func" slot-scope="row">
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" size="sm" @click="price_save(row.item);" variant="outline-success">Apply</b-btn>
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" @click="setting_modify = false;setting_modify_index = -1" size="sm" variant="outline-danger">Cancel</b-btn>
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-else @click="setting_modify = true;setting_modify_index = row.index;" size="sm" variant="outline-primary">Modify</b-btn>
                        <b-btn class="m-1" @click="setting_modify_confirm = true" v-if="published && row.item.is_publish && publish_list.indexOf(row.item.id) > -1" size="sm" variant="outline-warning">Publish</b-btn>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <br>
              <div class="d-flex flex-wrap">
                <div class="mr-auto">
                  <b-button size="sm" :disabled="published" variant="primary" @click="setting_modify_confirm = true">
                    {{published ? 'Published' : 'Publish' }}
                  </b-button>
                  </div>
                  <div class="">
                  <b-button v-if="published" size="sm" :disabled="!published" variant="warning" @click="service_append_confirm = true">
                    Add Exist Service to partner
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>Partner Group : [Owner]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>View</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 끝 -->
      <!-- 해당 파트너의 그룹 정보 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Group`s List" @click="() => this.$refs.list && this.$refs.list.refresh()">
        <b-card>
          <group-List v-if="check_owner" :partner="model" :addPartner="true" ref="_list"></group-List>
          <b-row v-else>
            <b-col sm="12">
              <center>
                <label>Partner Group : [Owner]</label>
                <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                <b-button variant="primary" @click="reload" block>View</b-button>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!-- 해당 파트너의 인보이스 목록 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="Invoice" @click="() => this.$refs.partner_list && this.$refs.partner_list.refresh()">
        <b-card>
          <InvoicePartnerList :ticket="true" :partner_id="model.id" ref="_list_invoice" />
          <b-button size="sm" class="pull-right" variant="primary" @click="confirm_ticket_invoice = true;" v-if="model.id">Ticket Invoice </b-button>
        </b-card>
      </b-tab>
    </b-tabs>

    <!-- 안내 모달 시작 -->
    <b-modal title="Deletion of information"  class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark">
      Are you sure you want to delete this user?
    </b-modal>
    <!-- 파트너 연결 모달 -->
    <b-modal size='xl' title="Connect Partner"  class="modal-primary" v-model="partner_connect_modal" ok-only ok-variant="outline-primary">
      <partner-List :enable_new="false" @select="select_partner" :view_detail="false"></partner-List>
    </b-modal>
    <!-- 크레딧 관련 히스토리 확인 모달 -->
    <b-modal title="[Manager -> Partner] Credit Grant History" size="xl" v-model="credit_history_modal" ok-variant="outline-primary" cancel-variant="outline-dark" ok-only>
      <b-table class="table table_add table-striped" hover small striped responsive="sm" ref="_list_credit_history" show-empty empty-text="There is no payment history!"
      :current-page="credit_history_opt.currentPage" :per-page="credit_history_opt.perPage"
      :items="get_credit_list" :fields="history" :sortBy="credit_history_opt.sk">
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="credit_amount" slot-scope="row">{{row.item.credit_amount | number}} </template>
        <template slot="service.list_price" slot-scope="row">{{row.item.service.list_price | number}} </template>
        <template slot="credit_info.invoice_id" slot-scope="row">{{row.item.invoice_id || '-'}} </template>
      </b-table>
      <b-row class="mt30">
        <b-col class="pagination justify-content-center">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="credit_history_opt.perPage" v-model="credit_history_opt.currentPage" prev-text="<" next-text=">"  />
        </b-col>
      </b-row>
      <!-- <b-button variant="primary" @click="credit_history_modal = false" block>Close</b-button> -->
    </b-modal>
    <!-- 크레딧 부여 확인 모달 -->
    <b-modal title="Manager -> Partner Credit Charging" v-model="Credit_Add" @ok="credit_control" ok-variant="primary">
      ${{amount}} Credit Charging??

    </b-modal>
    <!-- 가격 공개 부여 확인 모달 -->
    <b-modal title="Publish to partner's price" v-model="setting_modify_confirm" @ok="setting_publish" ok-variant="danger" header-bg-variant="danger">
      Do you handle the partner's price publicly?
      <hr>
      Only when public processing is complete can partners attract customers
    </b-modal>
    <!-- 파트너 초대 메일 발송 확인 모달 -->
    <b-modal title="Send invitation mail" v-model="mail_confirm" @ok="send_mail" ok-variant="info">
      Partner, everything is ready.
      <hr>
      Should I send an invitation email to partner ({{model.username}}) ?
    </b-modal>
    <!-- 가격 설정 안내 모달 -->
    <b-modal title="Partner price identification required" no-close-on-backdrop ok-only v-model="is_registed" @ok="index = 3" ok-variant="outline-warning" header-bg-variant="warning">
      Price settings remain for partner
      <br>
      Price information must be reflected before partners can create and manage end customers
    </b-modal>
    <!-- 서비스 추가 모델 -->
    <!-- <b-modal title="Another service to apply published partner" no-close-on-backdrop ok-only v-model="service_append_confirm" @ok="service_append" ok-variant="outline-warning" header-bg-variant="warning" size="xl" ok-title="확인"> -->
      <b-modal title="Another service to apply published partner" no-close-on-backdrop ok-only v-model="service_append_confirm" @ok="service_append_confirm = false" ok-variant="outline-warning" header-bg-variant="warning" size="xl">
      <SettingService
        :view_detail="false"
        @get_basic_service="(service_id) => { this.new_service_id = service_id; service_append() }"
      />

    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="Ticket Invoice"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="outline-primary" cancel-variant="outline-dark">
      <b-form-group>
        <p>please select the month of invoice</p>
        <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"> </vue-monthly-picker> -->
        <date-picker style="width: 100%;" type="month" v-model="ticket_invoice_month" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
        <small class="text-danger font-weight-bold">
          If it's already issued, force it to be issued.
          <br>
          Please check the amount of invoice generated.
          <br>
          An information mail will be sent when the invoice is issued.
        </small>
      </b-form-group>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  height: 100%;
}
</style>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>